<div fxLayout="row" fxLayoutAlign="space-between start" fxLayoutGap="30px" fxLayoutAlign.lt-md="start start" fxLayout.lt-md="column">
  <app-faq fxFlex="auto" fxFlex.lt-md="100"></app-faq>
  <app-contact-card class="contact-card"></app-contact-card>
</div>
